import { FC } from "react";
import { useTranslation } from "react-i18next";
import Breadcrumbs from "@dashboard/components/breadcrumbs/breadcrumbs";
import { UiButton } from "@domun/component-library";
import { DeliveryCheckoutSummary } from "../../components/delivery-checkout-summary/delivery-checkout-summary";
import { DeliveryPageWrapper } from "../../components/delivery-page-layout/delivery-page-layout.styled";
import { useDeliveryCheckout } from "../../hooks/use-delivery-checkout.hook";

const DeliveryCheckout: FC = () => {
  const { t } = useTranslation();
  const {
    calculation,
    selectedProvider,
    sizeLabel,
    typeLabel,
    loading,
    error,
    handleCreate,
    handleRecreate,
    breadcrumbs,
    linkedOrderId,
    partner,
  } = useDeliveryCheckout();

  if (!calculation) {
    return (
      <DeliveryPageWrapper>
        <p>{t("delivery.create.validationError")}</p>
      </DeliveryPageWrapper>
    );
  }

  return (
    <DeliveryPageWrapper>
      <div className="header">
        <Breadcrumbs items={breadcrumbs} backButton />
      </div>
      <h2>{t("delivery.checkout.title")}</h2>

      <DeliveryCheckoutSummary
        calculation={calculation}
        selectedProvider={selectedProvider}
        sizeLabel={sizeLabel}
        typeLabel={typeLabel}
        linkedOrderId={linkedOrderId}
        userCountry={partner?.userCountry}
      />

      {error && <p className="error-text">{error}</p>}

      <div className="actions">
        <UiButton
          onClick={handleCreate}
          isLoading={loading}
          disabled={loading}
        >
          {t("delivery.checkout.confirm")}
        </UiButton>
        {error && (
          <UiButton
            onClick={handleRecreate}
            isLoading={loading}
            disabled={loading}
          >
            {t("delivery.checkout.recreate")}
          </UiButton>
        )}
      </div>
    </DeliveryPageWrapper>
  );
};

export default DeliveryCheckout;
